import React, { useEffect, useRef, useState } from "react";
import "../../styles/CommonBbps.css";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import { isInputValid } from "../../Common/creditCardBinAPI/CommonFunctions";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { data } from "../../Common/Text/NormalText";
import Header from "../../components/Header/Header";
import NtarLoader from "../../components/Loaders/NtarLoader";
import { useLocation } from "react-router-dom";

const InstantBbps = () => {
  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in instant bbps ====>>", detailsToSend);
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const origin = location.state?.origin || "";

  const [parametersList, setParametersList] = useState([]);
  const [formData, setFormData] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [allFieldsValid, setAllFieldsValid] = useState(false);
  const [billFetchError, setBillFetchError] = useState(false);
  const [billFetchMandatory, setBillFetchMandatory] = useState(false);
  const [billamountValidations, setBillAmountValidations] = useState({
    minAmount: 0,
    maxAmount: 0,
  });
  const [billerId, setBillerId] = useState(null);
  const mapExistingToBillerParams = (billerParams = [], detailsToSend) => {
    if (!billerParams.length || !detailsToSend) return [];

    const existingMap = normalizeExistingParams(detailsToSend.parameters);

    return billerParams.map((param) => {
      let enteredValue = "";

      // ✅ CREDIT CARD → ALWAYS 16 DIGITS
      if (param.maxLength === 4 && detailsToSend.creditCardNumber) {
        enteredValue = detailsToSend.creditCardNumber.slice(-4);
      }

      // ✅ MOBILE NUMBER
      else if (param.maxLength === 10) {
        enteredValue =
          detailsToSend.customerMobileNumber ||
          existingMap["Registered Mobile Number"] ||
          existingMap["Mobile Number"] ||
          "";
      }

      // ✅ FALLBACK (DESC MATCH)
      else {
        enteredValue = existingMap[param.desc] || "";
      }

      return {
        ...param,
        enteredValue,
        key: param.name,
      };
    });
  };

  const normalizeExistingParams = (params) => {
    const result = {};

    // ✅ ARRAY HANDLING
    if (Array.isArray(params)) {
      params.forEach((p) => {
        if (p?.desc && p?.enteredValue) {
          result[p.desc] = p.enteredValue;
        }
      });
    }

    // ✅ OBJECT HANDLING
    else if (params && typeof params === "object") {
      Object.keys(params).forEach((key) => {
        result[key] = params[key];
      });
    }

    return result;
  };

  useEffect(() => {
    if (!parametersList.length) return;
    if (origin?.toLowerCase() !== "existing") return;

    const mappedParams = mapExistingToBillerParams(
      parametersList,
      detailsToSend,
    );

    const restoredFormData = {};
    const restoredTouched = {};

    mappedParams.forEach((param) => {
      if (param.enteredValue) {
        restoredFormData[param.name] = param;
        restoredTouched[param.name] = true;
      }
    });

    if (Object.keys(restoredFormData).length) {
      setFormData(restoredFormData);
      setTouched(restoredTouched);

      console.log("✅ Prefilled (array + object safe)", restoredFormData);
    }
  }, [parametersList, detailsToSend, origin, billerId]);

  /* ---------------- HANDLE INPUT CHANGE ---------------- */
  const handleInputChange = (item, value) => {
    setBillFetchError("");
    let enteredValue = value;

    // Only credit card fields: remove non-digits and limit to 16
    if (isCreditCardInput(item)) {
      enteredValue = enteredValue.replace(/\D/g, "").slice(0, 4);
    }
    // Other fields: enforce their maxLength if defined
    else if (item?.maxLength) {
      enteredValue = enteredValue.slice(0, item.maxLength);
    }

    setFormData((prev) => {
      const updated = {
        ...prev,
        [item.name]: {
          ...item,
          enteredValue,
        },
      };

      return updated;
    });

    setTouched((prev) => ({ ...prev, [item.name]: true }));
  };

  const sortBbpsParameters = (params = []) => {
    return [...params].sort((a, b) => {
      // Credit card field always first
      if (a.maxLength === 4 && b.maxLength !== 4) return -1;
      if (a.maxLength !== 4 && b.maxLength === 4) return 1;

      return 0; // keep original order
    });
  };

  const isCreditCardInput = (item) => {
    if (!item) return false;
    return item?.maxLength === 4;
  };

  const isMobileNumberInput = (item) => {
    if (!item) return false;
    return item?.maxLength === 10;
  };

  /* ---------------- FETCH BILLER INFO ---------------- */
  const loadBillerInfo = async (id) => {
    if (!id || loading) return;

    setLoading(true);

    try {
      const res = await Call_Api(
        path.INSTANTPAY_BILLER_DETAILS,
        "POST",
        { billerId: id, billType: "billerInfo" },
        token,
      );

      console.log("API response in loadBillerInfo ===>>", res);

      const data = res?.response?.data;
      const params = data?.parameters || [];

      setParametersList(sortBbpsParameters(params));
      setBillFetchMandatory(data?.fetchRequirement === "MANDATORY");

      const checkAgt = data?.initChannels.find((items) =>
        items.name.includes("AGT"),
      );
      const channelToBeSend = checkAgt ? "AGT" : "MOB";

      setBillerId(id);

      console.log("data?.initChannels ===>>", data?.initChannels);

      setBillAmountValidations({
        ...billamountValidations,
        minAmount: data?.initChannels?.[0]?.minAmount,
        maxAmount: data?.initChannels?.[0]?.maxAmount,
      });

      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          externalRef: data?.externalRefId,
          initChannel: channelToBeSend,
        }),
      );

      console.log("Biller info stored in sessionStorage");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- FORM VALIDATION ---------------- */
  useEffect(() => {
    const valid = parametersList.every((field) => {
      const value = formData[field.name]?.enteredValue || "";

      if (isCreditCardInput(field)) {
        return /^[0-9]{4}$/.test(value);
      }

      return (
        value.length === field.maxLength && new RegExp(field.regex).test(value)
      );
    });

    setAllFieldsValid(valid);
    console.log("Form validation status:", valid);
  }, [formData, parametersList]);

  useEffect(() => {
    loadBillerInfo(detailsToSend.billerId);
  }, []);

  /* ---------------- CONTINUE ---------------- */
  const handleContinue = async () => {
    let creditCardNumber = "";
    let bbpsCreditCardNumber = "";
    let customerMobileNumber = "";

    console.log("formData ===>>", formData);

    const inputParams = Object.values(formData).map((field) => {
      if (isCreditCardInput(field)) {
        creditCardNumber = field.enteredValue;
        bbpsCreditCardNumber = field.enteredValue;
      }

      if (isMobileNumberInput(field) && field.enteredValue?.length == 10) {
        customerMobileNumber = field.enteredValue;
      }

      return {
        ...field,
        key: field?.name,
      };
    });

    let payload = {};

    if (billFetchMandatory) {
      payload = {
        ...detailsToSend,
        creditCardNumber,
        bbpsCreditCardNumber,
        inputParams,
        billType: "billFetch",
      };
    } else {
      payload = {
        ...detailsToSend,
        creditCardNumber,
        bbpsCreditCardNumber,
        inputParams,
        billType: "billValidation",
      };
    }

    console.log("payload for bill enquiry ===>>", payload);

    try {
      setLoading(true);

      if (billFetchMandatory) {
        const res = await Call_Api(
          path.INSTANTPAY_BILL_ENQUIRY,
          "POST",
          payload,
          token,
          { timeout: 30000 },
        );
        console.log("Bill Enquiry Response ===>>", res);
        const dtaFromBack = res?.response?.data?.data;
        if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
          dispatch(
            setDetailsToSend({
              ...detailsToSend,
              CustomerName: dtaFromBack?.CustomerName,
              billAmount:
                Number(dtaFromBack?.BillAmount) > 200000
                  ? 200000
                  : dtaFromBack?.BillAmount,
              dueDate: dtaFromBack?.BillDueDate,
              billDate: dtaFromBack?.BillDate,
              requestId: dtaFromBack?.enquiryReferenceId,
              bbpsRequestId: dtaFromBack?.enquiryReferenceId,
              enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
              creditCardNumber,
              outstandingDue: dtaFromBack.AdditionalDetails.find(
                (item) => item.Name === "Maximum Permissible Amount",
              )?.Value,
              bbpsCreditCardNumber,
              bbpsGateWay: "INSTANT_BBPS",
              customerMobileNumber:
                origin?.toLowerCase() == "existing"
                  ? detailsToSend?.customerMobileNumber
                  : dtaFromBack?.CustomerParamsDetails?.find((item) =>
                      item?.Name?.includes("Mobile Number"),
                    )?.Value || customerMobileNumber,
              parameters: inputParams,
              inputParams,
              amountValidations: {
                ...billamountValidations,
                maxAmount:
                  Number(dtaFromBack?.BillAmount) > 200000
                    ? 200000
                    : dtaFromBack?.BillAmount,
              },
            }),
          );
          navigate("/payInstant");
        } else {
          setBillFetchError(res?.response?.data?.status);
        }
      } else {
        const res = await Call_Api(
          path.INSTANTPAY_VALIDATE_BILL,
          "POST",
          payload,
          token,
          { timeout: 30000 },
        );
        console.log("Bill Validation Response ===>>", res);
        const dtaFromBack = res?.response?.data?.data;
        if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
          dispatch(
            setDetailsToSend({
              ...detailsToSend,
              CustomerName: dtaFromBack?.CustomerName,
              billAmount:
                Number(dtaFromBack?.BillAmount) > 200000
                  ? 200000
                  : dtaFromBack?.BillAmount,
              dueDate: dtaFromBack?.BillDueDate,
              billDate: dtaFromBack?.BillDate,
              requestId: dtaFromBack?.enquiryReferenceId,
              bbpsRequestId: dtaFromBack?.enquiryReferenceId,
              enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
              creditCardNumber,
              bbpsGateWay: "INSTANT_BBPS",
              outstandingDue: dtaFromBack.AdditionalDetails.find(
                (item) => item.Name === "Maximum Permissible Amount",
              )?.Value,
              bbpsCreditCardNumber,
              customerMobileNumber:
                origin?.toLowerCase() == "existing"
                  ? detailsToSend?.customerMobileNumber
                  : dtaFromBack.CustomerParamsDetails.find((item) =>
                      item.Name.includes("Mobile Number"),
                    )?.Value || customerMobileNumber,
              parameters: inputParams,
              inputParams,
              amountValidations: {
                ...billamountValidations,
                minAmount: 100,
                maxAmount:
                  Number(dtaFromBack?.BillAmount) > 200000
                    ? 200000
                    : dtaFromBack?.BillAmount,
              },
            }),
          );
          navigate("/payInstant");
        } else {
          setBillFetchError(res?.response?.data?.status);
        }
      }
    } catch (err) {
      console.error("Error during processing:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (detailsToSend?.parameters?.length && parametersList.length) {
      const restoredFormData = {};
      const restoredTouched = {};

      detailsToSend.parameters.forEach((param) => {
        let enteredValue = param.enteredValue || "";

        // ✅ FORCE last 4 digits for credit card
        if (param.maxLength === 4 && enteredValue.length > 4) {
          enteredValue = enteredValue.slice(-4);
        }

        restoredFormData[param.name] = {
          ...param,
          enteredValue,
        };

        restoredTouched[param.name] = true;
      });

      setFormData(restoredFormData);
      setTouched(restoredTouched);
    }
  }, [detailsToSend?.parameters, parametersList]);
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;

      if (!detailsToSend?.serviceName) {
        navigate("/BBPS", { replace: true });
      }
    }
  }, [detailsToSend?.serviceName]);

  if (loading) {
    return <NtarLoader />;
  }

  return (
    <>
      <Header title="Credit Cards Bill Payments" />
      <div className="InstantBbps-container">
        <div className="back-icon-createlink_s_i">
          <KeyboardBackspaceIcon
            fontSize="large"
            onClick={() => {
              if (origin?.toLowerCase() == "existing") {
                sessionStorage.clear();
                dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
                navigate("/CreditCardInstantBbps");
              } else {
                sessionStorage.clear();
                dispatch(setDetailsToSend({ subService: "" }));
                if (
                  detailsToSend?.serviceName?.toLowerCase() == "credit card"
                ) {
                  navigate("/bbps/Credit Card Bbps", {
                    state: { record: "Credit Card" },
                  });
                } else {
                  navigate(`/bbps/${detailsToSend?.serviceName}`, {
                    state: { record: detailsToSend?.serviceName },
                  });
                }
              }
            }}
          />
        </div>
        <div className="title_s">{data?.enterPay}</div>
        <div className="titleImage_s_i">
          <img
            src={detailsToSend?.billerLogo}
            alt="noImage"
            className="bbpsImage_s"
          />
          <p className="Note_s_wA">{detailsToSend?.subService}</p>
        </div>
        <div className="card_s_i">
          {parametersList.map((item, idx) => {
            const value = formData[item.name]?.enteredValue || "";

            const status = isInputValid(
              value,
              item.minLength,
              item.maxLength,
              item.regex,
            );

            const showError = touched[item.name] && status === "InValid";

            return (
              <div key={idx} className="form-group my-3">
                <label>
                  {item.desc}
                  <span className="text-danger ms-1">*</span>
                </label>

                <input
                  type="text"
                  value={value}
                  maxLength={item.maxLength}
                  className={`form-control ${
                    status === "valid"
                      ? "is-valid"
                      : showError
                        ? "is-invalid"
                        : ""
                  }`}
                  onChange={(e) => handleInputChange(item, e.target.value)}
                  placeholder={item.desc}
                />

                {showError && (
                  <small className="text-danger">Invalid value</small>
                )}
              </div>
            );
          })}
          {billFetchError && <p className="error_s_i">{billFetchError}</p>}
          <p className="Note_s_wA">
            Note: Don't Refresh till the process is completed !
          </p>

          <button
            disabled={!allFieldsValid || loading || billFetchError}
            className="btn_s_i"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default InstantBbps;
